export const TRADE_GOLD_ACTION = {
    LOGIN_KYC_GOLD : "LOGIN_KYC_GOLD"
} 